var _defs, _path, _g, _path2, _text, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLi2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 442.071,
    height: 109.9,
    viewBox: "0 0 442.071 109.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 35.871,
    height: 35.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1311",
    "data-name": "Rectangle 1311",
    width: 82.577,
    height: 82.578,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(-81 -2746.416)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M345.889,109.282H90.105a54.95,54.95,0,0,0-54.949,54.949v0a54.95,54.95,0,0,0,54.949,54.949H345.889a22.383,22.383,0,0,0,17.135-7.981l31.964-38.026a13.9,13.9,0,0,0,0-17.885l-31.964-38.026a22.382,22.382,0,0,0-17.135-7.981",
    transform: "translate(103.639 2637.134)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(487.2 2784.302)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M282.957,150.264a17.936,17.936,0,1,1-17.936-17.936,17.936,17.936,0,0,1,17.936,17.936",
    transform: "translate(-247.086 -132.328)",
    fill: "#ff8206"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M269.088,146.36a7.971,7.971,0,1,1-7.972-7.97,7.97,7.97,0,0,1,7.972,7.97",
    transform: "translate(244.017 2655.878)",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Enhances_vendor_collaboration",
    "data-name": "Enhances vendor  collaboration",
    transform: "translate(194 2800)",
    fontSize: 20,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Enhances vendor "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "collaboration"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(81 2759)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M82.578,158.393A41.289,41.289,0,1,1,41.29,117.1a41.287,41.287,0,0,1,41.288,41.288",
    transform: "translate(0 -117.103)",
    fill: "#ff8206"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M62.114,152.633a26.584,26.584,0,1,1-26.584-26.584,26.585,26.585,0,0,1,26.584,26.584",
    transform: "translate(87.055 2647.951)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    transform: "translate(95.626 2760.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M19.823,32.021a.284.284,0,0,0-.138-.17l-3.041-1.63a.279.279,0,0,0-.133-.033.287.287,0,0,0-.254.15l-4.85,9.047a.29.29,0,0,0,.117.388l3.041,1.63a.279.279,0,0,0,.133.033.288.288,0,0,0,.254-.15l4.85-9.048A.283.283,0,0,0,19.823,32.021Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M33.74,74.076a.714.714,0,0,0-1.007,0l-.239.239a.413.413,0,0,1-.03.071.437.437,0,0,1-.247.205l-.46.46a.714.714,0,0,0,0,1.008.73.73,0,0,0,1.008,0l.976-.975A.715.715,0,0,0,33.74,74.076Z",
    transform: "translate(-14.254 -30.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M48.59,82.161a.712.712,0,0,0-1.216-.5l-.689.688-.289.289a.714.714,0,0,0,0,1.006.73.73,0,0,0,1.007,0l.355-.355v0l.274-.274.344-.344A.706.706,0,0,0,48.59,82.161Z",
    transform: "translate(-24.599 -36.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M41.732,76.24a.712.712,0,1,0-1.007-1.008l-1.79,1.79a.713.713,0,0,0,0,1.007.73.73,0,0,0,1.009,0l.557-.557,0,0,.447-.447Z",
    transform: "translate(-19.325 -31.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M96.222,39.386l-4.85-9.047a.287.287,0,0,0-.254-.15.282.282,0,0,0-.134.033l-3.04,1.629a.288.288,0,0,0-.117.387l4.85,9.049a.293.293,0,0,0,.388.116l3.041-1.63A.287.287,0,0,0,96.222,39.386Z",
    transform: "translate(-53.994 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M54.137,87.523a.709.709,0,0,0-.5.209L53.366,88l-.2.2a.711.711,0,0,0,.5,1.214h0a.708.708,0,0,0,.5-.209l.467-.465a.716.716,0,0,0,0-1.008A.706.706,0,0,0,54.137,87.523Z",
    transform: "translate(-29.381 -40.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M60.228,40.744a.44.44,0,0,1-.206.019L54.845,40l-4.121,3.144v4.172a1.467,1.467,0,0,0,1.743-.9l.475-1.958a.44.44,0,0,1,.119-.21l.651-.643,0,0,.251-.248a.44.44,0,0,1,.622,0,.435.435,0,0,1,.072.509l8.37,6.2c.019.014.034.033.053.048a2.9,2.9,0,0,0,1.476-1.668.444.444,0,0,1,.277-.3l.509-.182-4.062-7.578Z",
    transform: "translate(-27.802 -6.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M46.176,51.824l-8.456-6.26-.282.279-.455,1.875a.433.433,0,0,1-.024.071,2.289,2.289,0,0,1-2.189,1.5,2.705,2.705,0,0,1-.98-.181.44.44,0,0,1-.277-.409v-4.72a.439.439,0,0,1,.173-.35l1.819-1.388H32.8a.442.442,0,0,1-.253-.08l-.958-.671-3.983,7.43.664.2a.44.44,0,0,1,.295.3,3.476,3.476,0,0,0,.654,1.251l.1-.1a1.579,1.579,0,0,1,2.632.629l.289-.289a1.592,1.592,0,0,1,2.687,1.437,1.579,1.579,0,0,1,1.407,1.574,1.612,1.612,0,0,1-.019.2,1.577,1.577,0,0,1,1.03.456,1.594,1.594,0,0,1,.095,2.139l1.506,1.132a.816.816,0,0,0,.98-1.3.445.445,0,0,1-.079-.079l-3.318-2.592a.44.44,0,0,1,.542-.694L41.055,56.3a.815.815,0,0,0,.973-1.309.436.436,0,0,1-.075-.074l-4.211-3.261a.44.44,0,1,1,.539-.7l4.972,3.85a.814.814,0,0,0,1-1.282L38.807,49.5a.44.44,0,0,1,.524-.708l5.39,3.987c.011.007.023.012.034.021s.017.017.026.024l.41.3a.815.815,0,1,0,.983-1.3Z",
    transform: "translate(-11.471 -7.989)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi2);
export default __webpack_public_path__ + "static/media/li2.4eb7fbfad44869ca458cad159e75a78e.svg";
export { ForwardRef as ReactComponent };